'use strict';

import { connect } from 'react-redux';
import { IntlProvider } from 'react-intl';

/**
 * Connected Intl to props for LanguageSelector.
 * @version 0.5 FINAL - rev 15.8.2018
 * */
function mapStateToProps(state) {
    const lang = state.app.get('language');
    const messages = state.app.get('languageMessages');
    return { locale: lang, messages };
}

export default connect(mapStateToProps)(IntlProvider);



// WEBPACK FOOTER //
// ./src/components/ConnectedIntlProvider.js